import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { GalleryVerticalEnd, Eye } from "lucide-react";

type Props = {
    disabled?: boolean;
    onClick: () => void;
    showArchived?: boolean;
    activeLabel?: string;
    archivedLabel?: string;
}

export const SortArchiveButton = ({
    disabled = false,
    onClick,
    showArchived = false,
    activeLabel = "Show Active",
    archivedLabel = "Show Archived",
  }: Props) => {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    disabled={disabled}
                    size='action'
                    variant="secondary"
                    onClick={onClick}
                >
                    {showArchived ? (
                        <GalleryVerticalEnd size={16} />
                    ) : (
                        <Eye size={16} />
                    )}
                </Button>
            </TooltipTrigger>
            <TooltipContent>
                {showArchived ? activeLabel : archivedLabel} 
            </TooltipContent>
        </Tooltip>
    )
}
